import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { ToastVariant, useToastMessage } from '~/Hooks';

interface IPendingBooking {
  eventId: number;
  emailOrMemberId: string;
  requestedEndState: string;
}

export const useRequestPendingBooking = () => {
  const { showToast } = useToastMessage();
  const { t } = useTranslation();

  return useMutation(
    async (payload: IPendingBooking) => {
      const response = await requestReactQuery<any>({
        url: CORE_SERVICE_URLS.PENDING_BOOKINGS,
        data: payload,
        config: { method: 'POST' },
      });
      return response;
    },
    {
      onError: () =>
        showToast('location_creation_failed', t('app.default.error'), ToastVariant.ERROR, true),
    },
  );
};
